// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Heading_Heading__35fYu","fadeIn":"Heading_fadeIn__3rHSa","modalFadeIn":"Heading_modalFadeIn__1Dmp1","slideInFromRight":"Heading_slideInFromRight__2bmSu"};